import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrderById, fetchOrders } from '../slices/ordersSlice';
import { fetchClientById } from '../slices/clientSlice';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { Tool, File } from 'react-feather';
import OrderDetails from '../components/OrderDetails';
import Checklist from '../components/Checklist';
import { statusMapping } from '../formData/generalData';
import BncLogoSpinner from '../components/BncLogoSpinner';

export default function Repairs() {
	const dispatch = useDispatch();
	const orders = useSelector((state) => state.orders.items);
	// const workOrders = useSelector((state) => state.orders.items);
	const status = useSelector((state) => state.orders.listStatus);
	const error = useSelector((state) => state.orders.error);
	const [selectedOrder, setSelectedOrder] = useState(null);
	const [selectDetials, setSelectDetails] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');

	useEffect(() => {
		dispatch(fetchOrders());
	}, [dispatch]);

	if (status === 'loading') {
		return <BncLogoSpinner size={80} />;
	}

	if (status === 'failed') {
		return <div>Error: {error}</div>;
	}

	const openDetails = (orderId, clientId) => {
		setSelectedOrder(orderId);
		dispatch(fetchOrderById(orderId));
		dispatch(fetchClientById(clientId));
	};

	const openCheckList = (workOrders) => {
		setSelectDetails(workOrders);
	};



	return (
		<div className="flex flex-col h-screen">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<main className="flex-1 overflow-y-auto bg-slate-50 modern-dashboard">
					<div className="content-header">
						<h1>
							<Tool size={32} /> Repairs Management
						</h1>
					</div>

					<div className="table-card">
                        <div className="action-row">
							<div className="search-wrapper">
								<input 
									type="text" 
									placeholder="Search repairs..." 
									value={searchQuery}
									onChange={(e) => setSearchQuery(e.target.value)}
                                    className="pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
								/>
							</div>
						</div>

						<table className="modern-table">
							<thead>
								<tr>
									<th>Customer</th>
									<th>Order ID</th>
									<th>Date</th>
									<th>Status</th>
									<th>Email</th>
									<th className="text-right">Actions</th>
								</tr>
							</thead>
							<tbody>
								{orders
                                    .filter(order => {
                                        if (order.status !== 6) return false;
                                        if (!searchQuery) return true;
                                        const query = searchQuery.toLowerCase();
                                        const queryPhone = query.replace(/\D/g, '');
                                        return (
                                            (order.clientName || '').toLowerCase().includes(query) ||
                                            (order.clientEmail || '').toLowerCase().includes(query) ||
                                            (order.reference || '').toString().toLowerCase().includes(query) ||
                                            (queryPhone.length > 2 && (order.clientPhoneNumber || '').replace(/\D/g, '').includes(queryPhone))
                                        );
                                    })
                                    .map((order, index) => {
									return (
                                        <tr key={order.id} onClick={() => openDetails(order.id, order.clientId)}>
												<td>
													<div className="flex items-center gap-3">
														<div className={`avatar-initials bg-avatar-${(index % 5) + 1}`}>
															{order.clientName?.split(' ').map(n => n[0]).join('').toUpperCase() || '??'}
														</div>
														<div className="font-semibold text-slate-800">
															{order.clientName}
														</div>
													</div>
												</td>
												<td>
													<strong className="text-blue-600 font-mono">{order.reference}</strong>
												</td>
												<td>
													{new Date(order?.createdAt).toLocaleString('en-US', {
														month: '2-digit',
														day: '2-digit',
														year: '2-digit',
														hour: '2-digit',
														minute: '2-digit',
													})}
												</td>
												<td>
													<span className="status-pill status-Repair">
														{statusMapping[order.status]}
													</span>
												</td>
												<td className="text-slate-500 text-sm">
                                                    <div>{order.clientEmail}</div>
                                                    <div className="text-xs text-slate-400">{order.clientPhoneNumber}</div>
                                                </td>
												<td className="text-right">
													<button
														onClick={(e) => {
															e.stopPropagation();
															openDetails(order.id, order.clientId);
														}}
														className="p-2 text-slate-400 hover:text-blue-600 transition-colors"
													>
														<File size={20} />
													</button>
												</td>
											</tr>
									);
								})}
							</tbody>
						</table>
					</div>

					{selectedOrder && (
						<OrderDetails
							order={orders.find(o => o.id === selectedOrder)}
							onClose={() => setSelectedOrder(null)}
						/>
					)}
					{selectDetials && (
						<Checklist
							workOrders={selectDetials}
							onClose={() => setSelectDetails(null)}
						/>
					)}
				</main>
			</div>
		</div>
	);
}
